import { CustomAllocationPlanResponseAllocations, CustomAllocationResponse } from 'types/custom-plans';
import { Fund } from 'types/funds';

export function mapCustomPlanAllocations(
	allocations: Array<CustomAllocationPlanResponseAllocations>,
	offerings: Array<Fund>
): Array<CustomAllocationResponse> {
	return (
		(allocations
			.filter((allocation) => allocation.available)
			.map((allocation) => ({
				...offerings.find((offering) => offering.fundriseId === allocation.reitId),
				weight: +allocation.weight
			})) as Array<CustomAllocationResponse>) ?? []
	);
}
